<template>
    <div style="width: 100%;">
        <md-button class="md-icon-button" @click="toggleMenu">
          <md-icon>menu</md-icon>
        </md-button>
        <span class="md-display-1">Trivia de Tigre</span>
        <span class="md-caption" v-if="version">v{{version}}</span>

        <div class="md-toolbar-section-end" style="float: right;">
            <span>{{ user.name }}&nbsp;</span>
            <span><em>({{ user.email }})</em></span>
            <md-button class="md-icon-button">
                <md-icon>account_box</md-icon>
            </md-button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import firebase from 'firebase';
import {user} from '../helpers/user'

export default {
    name: 'HEADER',
    props: ['menuVisible'],
    data: () => ({
        user: user,
        version: process.env.VERSION
    }),
    methods: {
        toggleMenu: function () {
            this.$emit('toggleMenu')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Header.vue